import React, { memo } from 'react';
import { X } from 'lucide-react';

/**
 * Error indicator component
 * Shows LLM provider errors with dismiss functionality
 */
const ErrorIndicator = memo(({ 
  showLLMErrorIndicator, 
  LLMErrorIndicatorMessage, 
  dismissedErrorMessage,
  onDismiss 
}) => {
  // Don't show if error is dismissed or no error to show
  if (!showLLMErrorIndicator || !LLMErrorIndicatorMessage || dismissedErrorMessage === LLMErrorIndicatorMessage) {
    return null;
  }

  return (
    <div className="mb-3 p-3 bg-red-50 dark:bg-red-950/30 rounded-xl border border-red-200 dark:border-red-900">
      <div className="flex items-start gap-2">
        <svg className="w-5 h-5 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
        </svg>
        <div className="flex-1">
          <p className="text-sm font-medium text-red-800 dark:text-red-200 mb-1">
            LLM Provider Error
          </p>
          <p className="text-xs text-red-700 dark:text-red-300">
            {LLMErrorIndicatorMessage}
          </p>
        </div>
        <button
          onClick={onDismiss}
          className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 transition-colors p-1 hover:bg-red-100 dark:hover:bg-red-900/20 rounded-lg"
          title="Dismiss error"
          aria-label="Dismiss error"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
});

ErrorIndicator.displayName = 'ErrorIndicator';

export default ErrorIndicator;